<template>
  <div
    v-if="video"
    class="BaseVideo"
    :class="{
      'BaseVideo--full-width': fullWidth,
      'BaseVideo--bg-video': bgVideo,
    }"
  >
    <mux-player
      ref="player"
      stream-type="on-demand"
      :playback-id="video.video.muxPlaybackId"
      :placeholder="`data:image/jpeg;base64, ${video.thumbhash}`"
      :thumbnail-time="previewStartTime"
      :title="video.title"
      :style="!bgVideo && { aspectRatio: `${video.width}/${video.height}` }"
      :accent-color="resolvedConfig.theme.colors.black"
      :primary-color="resolvedConfig.theme.colors.white"
      :muted="isMuted"
      :autoplay="willAutoplay && !bgVideo"
      :loop="willLoop"
      preload="none"
    />
  </div>
</template>

<script>
import "@mux/mux-player"
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '@/tailwind.config.js'

export default {
  name: 'BaseVideo',

  props: {
    fullWidth: {
      type: Boolean,
      default: true,
    },
    video: {
      type: Object,
      required: true,
    },
    willAutoplay: {
      type: Boolean,
      default: true,
    },
    isMuted: {
      type: Boolean,
      default: true,
    },
    willLoop: {
      type: Boolean,
      default: false,
    },
    previewStartTime: {
      type: Number,
      default: 0,
    },
    bgVideo: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      resolvedConfig: resolveConfig(tailwindConfig),
      observer: null
    }
  },

  mounted() {
    if (!this.bgVideo || !this.$refs.player) return

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.playVideo()
        } else {
          this.pauseVideo()
        }
      })
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.2,
    })

    if (this.$refs.player) this.observer.observe(this.$refs.player)
  },

  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },

  methods: {
    playVideo () {
      if (!this.$refs.player) return
      this.$refs.player.play()
    },
    pauseVideo () {
      if (!this.$refs.player) return
      this.$refs.player.pause()
    }
  }
}
</script>

<style lang="postcss">
.BaseVideo {
  @apply relative z-[1] w-full global-wrapper;

  mux-player {
    --seek-backward-button: none;
    --seek-forward-button: none;
    --media-object-fit: cover;
    --media-object-position: center;
  }
}

/* Break out of wrapper - for fullwidth */
.BaseVideo--full-width {
  @apply w-[100vw] global-wrapper-reset;
}

.BaseVideo--bg-video {
  @apply absolute w-full h-full left-0 top-0 global-wrapper-reset;

  mux-player {
    --controls: none;
    --media-object-fit: cover;
    --media-object-position: center;
    height: 100%;
  }
}
</style>
